import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Terms and Conditions", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" By using AccidentPlan, you agree to the ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Terms and Conditions")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_5 = { class: "flex-wrapper flex-centered vertical-margin" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("I Agree")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("p", null, [
      _hoisted_2,
      _createVNode(_component_el_link, { style: {"text-decoration":"underline","font-size":"1em"} }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_el_button, {
        onClick: _ctx.onNext,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}